import { render, staticRenderFns } from "./PurchaseDeliveryItemTable.vue?vue&type=template&id=a8f4a0e4&scoped=true&"
import script from "./PurchaseDeliveryItemTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseDeliveryItemTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDeliveryItemTable.vue?vue&type=style&index=0&id=a8f4a0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f4a0e4",
  null
  
)

export default component.exports